import { createContext, useContext } from 'react';

export interface FaqService {
  getLocalizedArticle: (articleSlug: number | string) => string;
  getLocalizedHelpCenter: string;
}

export const faqService: FaqService = {
  getLocalizedArticle: (articleSlug: number | string) => articleSlug.toString(),
  getLocalizedHelpCenter: '',
};

const FaqServiceContext = createContext<FaqService>(faqService);

export function FaqServiceProvider({
  children,
  faqService: service = faqService,
}: {
  children: React.ReactNode;
  faqService?: FaqService;
}): React.ReactNode {
  return <FaqServiceContext.Provider value={service}>{children}</FaqServiceContext.Provider>;
}

export function useFaqService(): FaqService {
  return useContext(FaqServiceContext);
}
